module.exports = __webpack_public_path__ + "img/mobiledynamicBanner.d9fe08fa.png";